import { store } from '@src/store';
import { setUpdateFound } from './store/reducers/UIReducer';

export default function swDev() {
	if ('serviceWorker' in navigator) {
		window.addEventListener('load', function () {
			navigator.serviceWorker
				.register(`/sw.js`)
				.then((registration) => {
					console.log('SW registered: ', registration);

					registration.addEventListener('updatefound', () => {
						console.log('New service worker found');
						// registration.update();
					});
				})
				.catch((registrationError) => {
					console.log('SW registration failed: ', registrationError);
				});
		});
	}
}
